import Cookies from "js-cookie";
import { getUTMParams } from "../utils";

export function decorateUrlWithAttributionParams(url: URL): URL {
  const amplitudeId = Cookies.get("bws_amplitude_device_id");
  if (amplitudeId) {
    url.searchParams.set("amplitudeId", amplitudeId);
    url.searchParams.set("amplitude_device_id", amplitudeId);
  }

  const params = getUTMParams();
  if (!params) return url;

  const paramMap: Record<string, string | null> = {
    utm_source: params.utm_source,
    utm_medium: params.utm_medium,
    utm_campaign: params.utm_campaign,
    utm_content: params.utm_content,
    utm_term: params.utm_term,
    fbp: params.fbp,
    fbc: params.fbc,
    _fbp: params.fbp,
    _fbc: params.fbc,
  };

  Object.entries(paramMap).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value);
  });

  return url;
}
